import type { MgmtDecisionStatus, MgmtDecisionType, MgmtReviewStatus } from './types';

export const REVIEW_STATUS_LABEL: Record<MgmtReviewStatus, string> = {
  borrador: 'Borrador',
  en_curso: 'En curso',
  cerrada: 'Cerrada',
};

export const DECISION_TYPE_LABEL: Record<MgmtDecisionType, string> = {
  mejora: 'Mejora',
  recurso: 'Recurso',
  cambio_sgc: 'Cambio SGC',
  otro: 'Otro',
};

export const DECISION_STATUS_LABEL: Record<MgmtDecisionStatus, string> = {
  abierta: 'Abierta',
  en_progreso: 'En progreso',
  cerrada: 'Cerrada',
};

export function reviewStatusBadgeClass(status: MgmtReviewStatus): string {
  switch (status) {
    case 'cerrada':
      return 'bg-green-100 text-green-800';
    case 'en_curso':
      return 'bg-blue-100 text-blue-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
}

export function decisionStatusBadgeClass(status: MgmtDecisionStatus): string {
  switch (status) {
    case 'cerrada':
      return 'bg-green-100 text-green-800';
    case 'en_progreso':
      return 'bg-amber-100 text-amber-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
}

export function formatPeriodLabel(start: string, end: string): string {
  const from = new Date(start).toLocaleDateString('es-AR');
  const to = new Date(end).toLocaleDateString('es-AR');
  return `${from} — ${to}`;
}
